/**
 * The conversation without "changed" notes from before its first question:
 * they explain why later answers differ, and before the first question there
 * are no earlier answers to differ from. The server no longer writes them
 * there; this hides the ones already saved.
 */
export function withoutOpeningNotes(messages) {
  const first = messages.findIndex((m) => m.role === 'user');
  if (first === -1) {
    return messages.filter((m) => m.additional_data?.type !== 'knowledge_scope_changed');
  }
  return messages.flatMap((m, i) => {
    if (i < first && m.additional_data?.type === 'knowledge_scope_changed') return [];
    if (i === first && m.instructions_change) {
      const rest = { ...m };
      delete rest.instructions_change;
      return [rest];
    }
    return [m];
  });
}
